import React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import CloseIcon from '@mui/icons-material/Close';
import SlideUpTransition from './SlideUpTransition';
import GameSelecterCarousel from '../games/gameSelecterCarousel';
import { LeaderboardGameId } from '../../services/leaderboardService';

function GamesSelecterDialog ({
    open,
    onClose,
    launchGameId,
}: {
    open: boolean,
    onClose: () => void,
    launchGameId?: LeaderboardGameId,
}) {
    const isCompactScreen = useMediaQuery('(max-width: 768px)');

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={isCompactScreen}
            TransitionComponent={SlideUpTransition}
            sx={{
                '& .MuiDialog-paper': {
                    margin: isCompactScreen ? 0 : 2,
                    width: isCompactScreen ? '100vw' : 'auto',
                    maxWidth: isCompactScreen ? '100vw' : 'min(96vw, 1920px)',
                    maxHeight: isCompactScreen ? '100dvh' : 'min(95vh, 1080px)',
                    borderRadius: isCompactScreen ? 0 : 3,
                    background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)',
                    border: isCompactScreen ? '0' : '4px solid #FFD700',
                    boxShadow: isCompactScreen
                        ? 'none'
                        : '-8px -8px 0px 0px rgba(0, 0, 0, 0.5), 0px 8px 16px 0px rgba(0, 0, 0, 0.8), inset 0px 0px 0px 2px rgba(255, 255, 255, 0.1)',
                    overflow: 'hidden',
                    position: 'relative',
                },
            }}
        >
            <IconButton
                aria-label="Close dialog"
                onClick={onClose}
                size="small"
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 20,
                    color: '#fff',
                    backgroundColor: 'rgba(0, 0, 0, 0.45)',
                    border: '1px solid rgba(255, 215, 0, 0.6)',
                    '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.65)' },
                }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
            <GameSelecterCarousel launchGameId={launchGameId} onCloseRequested={onClose} />
        </Dialog>
    );
};

export default GamesSelecterDialog;